import React from 'react';
export const VisionUserConfigContext = React.createContext(undefined);
